// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_udIOI","banner":"banner_sAc0Q","image":"image_Z-XCT"};